import { render, staticRenderFns } from "./FormLabelTitulo.vue?vue&type=template&id=5081878c"
import script from "./FormLabelTitulo.vue?vue&type=script&lang=js"
export * from "./FormLabelTitulo.vue?vue&type=script&lang=js"
import style0 from "./FormLabelTitulo.vue?vue&type=style&index=0&id=5081878c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports